import { AfterViewInit, ChangeDetectorRef, Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Console } from 'console';
import { base64Decode, stringToCode } from 'encoding-japanese';
import {
  LOGIN_DONE_AGENDA_SOLUTIONS,
  LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC,
  API_URL_APPLICATIONS_FILES,
  DUPLICATE_AGENDA_SOLUTION,
} from 'manager/http-constants';
import { forkJoin, Observable } from 'rxjs';
import {
  API_RESPONSE,
  INPUT_INFORMATIONS_API_CONSTANT,
} from 'src/app/shared/constant/api-constant';
import {
  CONSTANT,
  LOADING_KEY,
  IMAGE_EXTENSION,
  NUMBER,
} from 'src/app/shared/constant/constant';
import { MESSAGE_CODE } from 'src/app/shared/constant/message-constant';
import { TOAST } from 'src/app/shared/constant/primeng-constants';
import { GENERATE_INPUT_TYPE } from 'src/app/shared/generate/generate-input/constant';
import {
  LoadData,
  LoadingState,
} from 'src/app/shared/html-parts/loading/loading-state';
import {
  MessageData,
  ToastMessageData,
} from 'src/app/shared/html-parts/message-common/message-data';
import { CommonService } from 'src/app/shared/service/common.service';
import { DbOperationService } from 'src/app/shared/service/db-operation.service';
import { Validator } from 'src/app/shared/validator/validator';
import { PlatformComponent } from '../platform.component';
import { LoginService } from 'src/app/shared/service/login.service';
import { SESSION_KEY } from 'src/app/shared/constant/session-constants';

@Component({
  selector: 'app-c101',
  templateUrl: './c101.component.html',
  styleUrls: ['./c101.component.scss', '../platform.component.scss'],
})

/**
 * 課題・ソリューション登録(C101)
 * 課題・ソリューション登録確認(C102)
 */
export class C101Component extends PlatformComponent implements AfterViewInit{
  // 画面.入力フォーム
  c101InputForm: FormGroup = this.formBuilder.group({
    // タイトル
    title: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'agenda_solution',
          'title',
          INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
        ),
      ],
    }),
    // カテゴリ
    category: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'agenda_solution',
          'category',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // 図・写真
    image: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'agenda_solution',
          'image',
          INPUT_INFORMATIONS_API_CONSTANT.FILE_TYPE
        ),
      ],
    }),
    // 達成したいゴール
    sdgs_goal: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'agenda_solution',
          'sdgs_goal',
          INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
        ),
      ],
    }),
    // webサイト掲載終了日
    end_date: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'agenda_solution',
          'end_date',
          INPUT_INFORMATIONS_API_CONSTANT.DATE_TYPE
        ),
      ],
    }),
    // 公開掲示板の設定
    board_open: this.formBuilder.control(CONSTANT.EMPTY_STRING, {
      asyncValidators: [
        this.validator.CheckValidator(
          'agenda_solution',
          'board_open',
          INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
        ),
      ],
    }),
  });

  // 課題IDを格納
  agendaId: string = this.route.snapshot.queryParams.agenda_id;

  // 区分を格納
  agendaKbn: number = this.route.snapshot.queryParams.agenda_kbn;

  // 確認画面表示フラグ(true=課題・ソリューション登録確認(C102),false=課題・ソリューション登録(C101))
  confirmationFlag: boolean = false;

  // 画像情報保持
  searchResultsList: any;

  // 画像ID存在フラグ
  caseImgId: boolean = false;

  // file_path
  file_path: string = this.route.snapshot.queryParams.file_path;

  //ファイル名
  file_name: string = this.route.snapshot.queryParams.file_name;

  // 修正フラグ
  retouchFlg: boolean = false;

  // 代行会員情報
  alternateUser: any = JSON.parse(sessionStorage.getItem(SESSION_KEY.altUserBySecretariat));

  constructor(
    public route: ActivatedRoute,
    public commonService: CommonService,
    public dbOperationService: DbOperationService,
    public loadingState: LoadingState,
    private router: Router,
    private formBuilder: FormBuilder,
    private validator: Validator,
    private messageData: MessageData,
    private loginService: LoginService,
    private cdr: ChangeDetectorRef,

  ) {
    super(route, commonService, dbOperationService, loadingState);

    // urlを課題・ソリューション登録(C101)に変更する
    this.router.navigate(['pages/platform/c101/' + this.inputType], {
      queryParams: {
        screenId: 'c101',
        agenda_id: this.agendaId,
        agenda_kbn: this.agendaKbn ? this.agendaKbn : CONSTANT.EMPTY_STRING,
      },
    });
  }
  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  async ngOnInit(): Promise<void> {
    // 区分を判定
    if (1 == this.agendaKbn) {
      // 課題の場合

      // 解決したい課題内容
      this.c101InputForm.addControl(
        'agenda',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'agenda',
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
            ),
          ],
        })
      );

      // 課題に対する現在の取り組み
      this.c101InputForm.addControl(
        'measures',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'measures',
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
            ),
          ],
        })
      );

      // 提案者側に期待すること
      this.c101InputForm.addControl(
        'expectations',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'expectations',
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
            ),
          ],
        })
      );

      // 定量的な目標値があれば記載ください
      this.c101InputForm.addControl(
        'target',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'target',
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
            ),
          ],
        })
      );

      // 予算状況
      this.c101InputForm.addControl(
        'budget',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'budget',
              INPUT_INFORMATIONS_API_CONSTANT.SINGLE_SELECT_TYPE
            ),
          ],
        })
      );

      // 予算状況に関する補足
      this.c101InputForm.addControl(
        'budget_note',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'budget_note',
              INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
            ),
          ],
        })
      );

      // 予算化の方法
      this.c101InputForm.addControl(
        'budget_method',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'budget_method',
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
            ),
          ],
        })
      );
    } else if (2 == this.agendaKbn) {
      // ソリューションの場合

      // ソリューション内容
      this.c101InputForm.addControl(
        'solution_detail',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'solution_detail',
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
            ),
          ],
        })
      );

      // 連携希望先
      this.c101InputForm.addControl(
        'image_group',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'image_group',
              INPUT_INFORMATIONS_API_CONSTANT.CHECKBOX_TYPE
            ),
          ],
        })
      );

      // ソリューション紹介URL
      this.c101InputForm.addControl(
        'solution_url',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'solution_url',
              INPUT_INFORMATIONS_API_CONSTANT.TEXT_TYPE
            ),
          ],
        })
      );

      // その他
      this.c101InputForm.addControl(
        'solution_note',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'solution_note',
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
            ),
          ],
        })
      );

      // 導入費用等の情報
      this.c101InputForm.addControl(
        'introcost_info',
        this.formBuilder.control(CONSTANT.EMPTY_STRING, {
          asyncValidators: [
            this.validator.CheckValidator(
              'agenda_solution',
              'introcost_info',
              INPUT_INFORMATIONS_API_CONSTANT.TEXTAREA_TYPE
            ),
          ],
        })
      );
    }
    await this.getUserLogin();

    // 辞書値リストを取得
    this.getSpecCodeList(1, 3, 701, 2021);

    // 課題カテゴリを取得
    this.getAgendaCategoryList();

    // 変動フォームコントロールを設定

    // 編集初期表示
    this.setEditInitialData();
  }

  async getUserLogin(){
    return new Promise(resolve => {
      this.loginService.getAuth0LoginState().subscribe((response) => {
        // ログイン状態をセット

        // ログイン状態を判定
        if (response) {
          // ログイン状態の場合

          /* ログインユーザー情報 */
          // セッションからログインユーザ情報取得
          const loginUser = JSON.parse(
            window.sessionStorage.getItem(SESSION_KEY.loginUserInformation)
          );

          // セッションにログインユーザ情報が存在するか否か
          if (loginUser) {
            // セッションにログインユーザが存在する場合

            // 課題・ソリューション結果を取得
            return resolve(null);
          } else {
            // セッションにログインユーザが存在しない場合(初回表示時)

            // ログインユーザ情報取得処理
            this.loginService.getLoginUser().subscribe((response) => {
              // 正常なユーザの為、セッションにユーザ情報を格納
              window.sessionStorage.setItem(
                SESSION_KEY.loginUserInformation,
                JSON.stringify(response.body[0])
              );

              this.loginUser = JSON.parse(window.sessionStorage.getItem(SESSION_KEY.loginUserInformation));
              // 課題・ソリューション結果を取得
              return resolve(null);
            });
          }
        } else {
          // 未ログイン状態の場合

          return resolve(null);
        }
      });
    });

  }

  /**
   * 編集初期表示
   */
  private setEditInitialData() {
    // 登録タイプ判定
    if ((GENERATE_INPUT_TYPE.NEW == this.inputType)) {
      // 編集以外の場合
      return;
    }
    // fpt added: get data for when editing
    if(GENERATE_INPUT_TYPE.EDIT == this.inputType){
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);

      // 課題・ソリューション詳細を取得
      this.dbOperationService
      .getNoTemplateDisplayData(LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC, this.agendaId)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }
        if(!this.decisionPerspective(response.body[0].member_id)
          && !this.decisionSecretariat()
        ){
          // 異常メッセージ
          this.messageData.toastMessage(
            new ToastMessageData({
              severity: TOAST.ERROR,
              summary: this.commonService.msg(MESSAGE_CODE.E00003),
              detail: this.commonService.msg(MESSAGE_CODE.E80002),
              position: TOAST.BOTTOM_RIGHT,
              life: 60000,
            })
          );
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }
        if(response.body[0].created_by_follow == '1'){
          this.loginService.logout(MESSAGE_CODE.N90001);
          return;
        }
        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.c101InputForm,
          response.body[0]
        );

        // 検索結果を保持
        this.searchResultsList = response.body[0];

        // 画像ID存在フラグを設定する
        if (this.searchResultsList.image.id != CONSTANT.EMPTY_STRING && this.searchResultsList.image.id.length != 0) {
          this.caseImgId = true;
          this.file_path = this.searchResultsList.image.file_path;
          this.file_name = this.searchResultsList.image.file_name;
        }

        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, LOGIN_NOT_AGENDA_SOLUTIONS_CLOSE_LOGIC);
      });
    // fpt added get data when citing issue
    }else{
      // 画面ロードフラグをON(ロード中状態)
      this.loadingState.loadStart(DUPLICATE_AGENDA_SOLUTION);

      // 課題・ソリューション詳細を取得
      this.dbOperationService
      .getNoTemplateDisplayData(DUPLICATE_AGENDA_SOLUTION, this.agendaId)
      .subscribe((response) => {
        if (this.commonService.checkNoneResponse(response)) {
          return;
        }

        // 初期値セット
        this.commonService.setFormGroupInitialData(
          this.c101InputForm,
          response.body[0]
        );

        // 検索結果を保持
        this.searchResultsList = response.body[0];

        // 画像ID存在フラグを設定する
        if (this.searchResultsList.image.id != CONSTANT.EMPTY_STRING && this.searchResultsList.image.id.length != 0) {
          this.caseImgId = true;
          this.file_path = this.searchResultsList.image.file_path;
          this.file_name = this.searchResultsList.image.file_name;
        }

        if(this.c101InputForm.controls['title'].value.length> 50){
          this.c101InputForm.controls['title'].markAsDirty();
        }
        if(this.c101InputForm.controls['agenda'].value.length > 400){
          this.c101InputForm.controls['agenda'].markAsDirty();
        }
        if(this.c101InputForm.controls['measures'].value.length > 400){
          this.c101InputForm.controls['measures'].markAsDirty();
        }
        if(this.c101InputForm.controls['expectations'].value.length > 400){
          this.c101InputForm.controls['expectations'].markAsDirty();
        }
        if(this.c101InputForm.controls['target'].value.length > 400){
          this.c101InputForm.controls['target'].markAsDirty();
        }
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, DUPLICATE_AGENDA_SOLUTION);
      });
    }
  }

  /**
   * 課題・ソリューション登録(C101)を表示する
   */
  public moveC101(): void {
    // 課題・ソリューション登録(C101)へ遷移
    this.router.navigate(
      ['pages/platform/c101/' + this.route.snapshot.params.inputType],
      {
        queryParams: {
          screenId: 'c101',
          agenda_id: this.agendaId,
          agenda_kbn: this.agendaKbn ? this.agendaKbn : CONSTANT.EMPTY_STRING,
        },
      }
    );

    // 課題・ソリューション登録(C101)を表示する
    this.confirmationFlag = false;

    // 修正フラグを立てる
    this.retouchFlg = true;
  }

  /**
   * 課題・ソリューション登録確認(C102)を表示する
   */
  public moveC102(): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let c101InputForm: any = JSON.parse(
      JSON.stringify(this.c101InputForm.value)
    );

    // 配列をカンマ区切り変換
    {
      // カテゴリ
      c101InputForm.category = c101InputForm.category.toString();

      // 達成したいゴール
      c101InputForm.sdgs_goal = c101InputForm.sdgs_goal.toString();

      // 区分を判定
      if (2 == this.agendaKbn) {
        // ソリューションの場合

        // 連携先想定
        c101InputForm.image_group = c101InputForm.image_group.toString();
      }
    }

    // 画面カスタムロードフラグをON(ロード中状態)
    this.loadingState.customLoadStart(
      new LoadData({
        loadingText: '',
        background_color: '',
        opacity: 0.3,
      })
    );

    /* 入力項目値バリデーションチェック */
    // 非同期同時実行リスト
    let task: Observable<any>[] = [
      /* 共通バリデーションチェック */
      this.dbOperationService.multiValidationResult(
        'agenda_solution',
        c101InputForm
      ),
    ];

    // 非同期同時実行
    forkJoin(task).subscribe((dataList) => {
      // レスポンスを結合
      // const data = this.generateService.JoinValidationResponseList(dataList);

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadEnd();

      // 課題・ソリューション登録確認(C102)へ遷移
      this.router.navigate(
        ['pages/platform/c101/' + this.route.snapshot.params.inputType],
        {
          queryParams: {
            screenId: 'c102',
            agenda_id: this.agendaId,
            agenda_kbn: this.agendaKbn ? this.agendaKbn : CONSTANT.EMPTY_STRING,
            file_path: this.file_path,
          },
        }
      );

      // 課題・ソリューション登録確認(C102)を表示する
      this.confirmationFlag = true;
    });
  }

  /**
   * 課題・ソリューション登録完了(C103)へ遷移する
   * @param status 1:登録 0:一時保存
   */
  public moveC103(status: string): void {
    // 画面.入力フォームから入力内容を取得
    // ※値渡し
    let c101InputForm: any = JSON.parse(
      JSON.stringify(this.c101InputForm.value)
    );

    // 会員ID(事務局による代行登録なら、alternateUser.member_idを設定する)
    if (this.decisionSecretariat() && this.existAlternateUser()) {
      c101InputForm.member_id = this.alternateUser.member_id;
    } else {
      c101InputForm.member_id = this.getLoginMemberId();
    }

    // 区分
    c101InputForm.agenda_kbn = this.agendaKbn;

    // ステータス
    c101InputForm.status = status;

    // 配列をカンマ区切り変換
    {
      // カテゴリ
      c101InputForm.category = c101InputForm.category.toString();

      // 達成したいゴール
      c101InputForm.sdgs_goal = c101InputForm.sdgs_goal.toString();

      // 区分を判定
      if (2 == this.agendaKbn) {
        // ソリューションの場合

        // 連携先想定
        c101InputForm.image_group = c101InputForm.image_group.toString();
      }
    }

    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(LOADING_KEY.DATA_INSERT);

    // 登録タイプ判定
    if (GENERATE_INPUT_TYPE.NEW == this.inputType) {
      // 新規登録の場合

      // 課題・ソリューション登録を実施
      this.dbOperationService
        .insertData(LOGIN_DONE_AGENDA_SOLUTIONS, c101InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合、代行会員情報を初期化
            this.initAltUserBySecretariat();

            // 課題・ソリューション登録完了(C103)へ遷移
            this.router.navigate(['pages/platform/c103'], {
              queryParams: {
                status: status,
              },
            });
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E90003),
              })
            );

            // 課題・ソリューション登録(C101)を表示する
            this.confirmationFlag = false;
          }
        });
    } else if (GENERATE_INPUT_TYPE.EDIT == this.inputType) {
      // 編集の場合

      // 課題・ソリューション更新を実施
      this.dbOperationService
        .updateData(LOGIN_DONE_AGENDA_SOLUTIONS, this.agendaId, c101InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合、代行会員情報を初期化
            this.initAltUserBySecretariat();

            // 課題・ソリューション登録完了(C103)へ遷移
            this.router.navigate(['pages/platform/c103'], {
              queryParams: {
                status: status,
              },
            });
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E90003),
              })
            );

            // 課題・ソリューション登録(C101)を表示する
            this.confirmationFlag = false;
          }
        });
    //fpt added: citing issue
    }else if (GENERATE_INPUT_TYPE.DUPLICATE == this.inputType) {
      // 新規登録の場合

      // 課題・ソリューション登録を実施
      this.dbOperationService
        .insertData(LOGIN_DONE_AGENDA_SOLUTIONS, c101InputForm)
        .subscribe((response) => {
          // 画面ロードフラグをOFF(ロード終了)
          this.loadingState.loadSleepEnd(0.3, LOADING_KEY.DATA_INSERT);

          // レスポンス結果を判定
          if (API_RESPONSE.SUCCESS == response.body.Message) {
            // 正常終了の場合、代行会員情報を初期化
            this.initAltUserBySecretariat();

            // 課題・ソリューション登録完了(C103)へ遷移
            this.router.navigate(['pages/platform/c103'], {
              queryParams: {
                status: status,
              },
            });
          } else {
            // 異常終了の場合

            // 異常終了メッセージ
            this.messageData.toastMessage(
              new ToastMessageData({
                severity: TOAST.ERROR,
                summary: this.commonService.msg(MESSAGE_CODE.E00001),
                detail: this.commonService.msg(MESSAGE_CODE.E90003),
              })
            );

            // 課題・ソリューション登録(C101)を表示する
            this.confirmationFlag = false;
          }
        });
    }
  }

  /**
   * プリントプレビュー画面を表示
   */
  public print(): void {
    window.print();
  }

  /**
   * ファイルアップロード
   * @param event ファイル情報
   * @param fileUpload ボタン動作状態
   * @param formName フォーム項目名
   */
  public uploadFile(event: any, fileUpload: any, formName: string) {
    // 画面ロードフラグをON(ロード中状態)
    this.loadingState.loadStart(API_URL_APPLICATIONS_FILES);

    // ファイル情報からファイル名を取得
    const fileName = event.files[0].name;

    // 拡張子を取得
    const extension = event.files[0].name.substring(
      event.files[0].name.lastIndexOf(CONSTANT.PERIOD)
    );

    // 拡張子が".jpg" or ".jpeg" or ".png"か否か判定
    if (
      !(IMAGE_EXTENSION.JPG == extension || IMAGE_EXTENSION.JPEG == extension || IMAGE_EXTENSION.PNG == extension || IMAGE_EXTENSION.JPG2 == extension || IMAGE_EXTENSION.JPEG2 == extension || IMAGE_EXTENSION.PNG2 == extension)
    ) {
      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);

      // 拡張子が".jpg" or ".jpeg" or ".png"
      // or".JPG" or ".JPEG" or ".PNG"以外の場合
      // 拡張子エラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(MESSAGE_CODE.E00013, 'jpg又はjpeg又はpng'),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイルサイズの判定
    if (NUMBER.ZERO == event.files[0].size || (10485760 / 2) <= event.files[0].size) {

      // 画面ロードフラグをOFF(ロード終了)
      this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);
      // ファイルサイズが0KBの場合 または
      // 5MB以上の場合

      // 画像サイズエラーメッセージ
      this.messageData.toastMessage(
        new ToastMessageData({
          severity: TOAST.WARN,
          summary: this.commonService.msg(MESSAGE_CODE.E00012),
          detail: this.commonService.msg(MESSAGE_CODE.E00031, '5MB以内'),
        })
      );

      // ボタン動作状態をクリア
      fileUpload.clear();

      // 処理を終了
      return;
    }

    // ファイル情報(base64)取得処理
    this.commonService.getBase64(event.files[0]).then((b64) => {
      const csize = 3000000; //3MBで分割
      var lc = (Math.floor(b64.length / csize) + 1)  //全ループ回数＝分割数
      var s: number;
      var e: number;
      var b64_konkai: string;    //ループ毎に処理するbase64エンコード
      var b64_arr = new Array   //バッファ

      //先頭部分の除去
      b64 = b64.replace(/^data:.*?;base64,/, '');

      for (var c = 0; c < lc; c++) {
        //開始Indexと終了Index
        s = c * csize
        e = (s + csize);
        if (e >= b64.length) {
          e = b64.length;
        }

        //バッファ配列にセット
        b64_konkai = b64.substring(s, e);
        b64_arr.push(b64_konkai)
      }

      // ファイル登録を実施 処理部分
      const file_register = (b64_arr: Array<any>, lc: number) => {
        return new Promise(resolve => {
          this.dbOperationService
            .insertFileResult(API_URL_APPLICATIONS_FILES, fileName, b64_arr[0], 1, lc)
            .subscribe((response) => {
              // 画面.入力フォームにファイルIDを格納
              this.c101InputForm.get(formName).setValue(response.body.file_id);

              // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
              this.c101InputForm.get(formName).markAsDirty();

              // ファイルパスを保持
              this.file_path = response.body.file_path;

              // ファイル名を保持
              this.file_name = fileName;

              //分割2回目～
              if (lc >= 2) {
                var arr = new Array;
                for (var c = 2; c <= lc; c++) {
                  arr.push(c);
                }
                (async () => {
                  for await (var num of arr) {
                    const res = await file2_register(num);
                  }
                  resolve("ok");
                })();
              } else resolve("ok");

              const file2_register = (n: number) => {
                return new Promise(resolve2 => {
                  this.dbOperationService
                    .insertFileResult(API_URL_APPLICATIONS_FILES, fileName, b64_arr[n - 1], n, lc)
                    .subscribe((response) => {
                      resolve2(response.body);
                    });
                })
              }
            });
        })
      }

      // ファイル登録を実施
      (async () => {
        const f_s = await file_register(b64_arr, lc);
        // 画面ロードフラグをOFF(ロード終了)
        this.loadingState.loadSleepEnd(0.3, API_URL_APPLICATIONS_FILES);
      })();
    });

    // 修正フラグを立てる
    this.retouchFlg = false;

    // 初期画像表示ID削除
    this.breakImgCaptionFlg(formName);
  }

  /**
   * アップロードファイル削除
   * @param formName フォーム項目名
   */
  public deleteFile(formName: string) {
    // 画面.入力フォームからファイル情報を削除
    this.c101InputForm.get(formName).setValue(CONSTANT.EMPTY_STRING);

    // フォームコントロール(ファイル登録)変更検知をtrueにする(エラーメッセージ表示有無フラグ)
    this.c101InputForm.get(formName).markAsDirty();

    // 確認画面へ渡すファイルパスを削除
    this.file_path = CONSTANT.EMPTY_STRING;

    // 確認画面へ渡すファイル名を削除
    this.file_name = CONSTANT.EMPTY_STRING;

    // 修正フラグを立てる
    this.retouchFlg = false;

    // 初期画像表示ID削除
    this.breakImgCaptionFlg(formName);
  }

  /**
   * 初期画像IDフラグの削除
   * @param formName フォーム項目名
   */
  public breakImgCaptionFlg(formName: string): void {
    // フラグを折る
    if (this.caseImgId && formName == "image") {
      this.caseImgId = false;
    }
  }

  /**
   * 代行会員情報ありなし
   * @returns true 代行会員情報あり
   * @returns false 代行会員情報なし
   */
  public existAlternateUser(): boolean {
    if (this.alternateUser == null) {
      return false;
    }
    if (this.alternateUser.member_id?.length == 0) {
      return false;
    } else {
      return true;
    }
  }
}
